import { Deck } from "@/engine/Deck";
import { AuroraBackground } from "@/ui";

export function App() {
  return (
    <div className="fixed inset-0 overflow-hidden bg-ink-950 text-white/90">
      <AuroraBackground />
      <div className="absolute inset-0 z-10">
        <Deck />
      </div>
    </div>
  );
}

export default App;
